import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'

// Detecta quando saiu uma nova versão do app (deploy) e oferece um botão de
// "Atualizar" — assim o usuário não precisa saber dar Ctrl+Shift+R.
// Como? O index.html é servido sem cache e aponta pro bundle com hash novo a cada
// build. A gente lê o nome do bundle no boot e, de tempos em tempos (e ao focar a
// aba), compara com o index.html atual do servidor. Se mudou → nova versão.
async function bundleAtual(): Promise<string | null> {
  try {
    const r = await fetch('/index.html', { cache: 'no-store' })
    const txt = await r.text()
    const m = txt.match(/assets\/index-[A-Za-z0-9_-]+\.js/)
    return m ? m[0] : null
  } catch {
    return null
  }
}

let carregado: string | null = null

export default function VersionWatcher() {
  const [novaVersao, setNovaVersao] = useState(false)

  useEffect(() => {
    let parar = false
    // Versão que está rodando agora (a que o navegador carregou neste load)
    bundleAtual().then((b) => { if (!parar && b) carregado = b })

    const checar = async () => {
      if (parar || novaVersao) return
      const b = await bundleAtual()
      if (b && carregado && b !== carregado) setNovaVersao(true)
    }
    const id = window.setInterval(checar, 60_000)  // a cada 1 min
    const onFocus = () => checar()
    window.addEventListener('focus', onFocus)
    return () => { parar = true; window.clearInterval(id); window.removeEventListener('focus', onFocus) }
  }, [novaVersao])

  if (!novaVersao) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[200] flex items-center gap-3
                    bg-brand-600 text-white rounded-full shadow-2xl pl-4 pr-2 py-2 text-sm font-medium
                    animate-in fade-in slide-in-from-bottom-2">
      <RefreshCw size={16} />
      <span>Nova versão disponível</span>
      <button onClick={() => window.location.reload()}
        className="bg-white text-brand-700 font-bold rounded-full px-3 py-1 hover:bg-brand-50">
        Atualizar
      </button>
    </div>
  )
}
